import { Typography } from '@mui/material';
import type { PropsWithChildren } from 'react';

export const ContentMainHeader = ({ children }: PropsWithChildren) => (
    <Typography variant="h2" fontFamily="Right Grotesk" fontSize="1.7em" fontWeight={600} mt={3}>
        {children}
    </Typography>
);
